module.exports = __webpack_public_path__ + "img/linkedin.506dc493.svg";